module.exports = __webpack_public_path__ + "static/media/ZapytanieOfertowe1.163c01df.pdf";